<div class="content" *ngIf="isMspLoaded">
  <div class="container-fluid">
    <div class="page-title clearfix license-title">
      <h1>Payment Management</h1>
    </div>
    <div class="page-filter clearfix two-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-multiSelect [options]="regionOptions"  (onPanelHide)="filter_region()" [baseZIndex]="10000" [(ngModel)]="filterRegion.RegionIds" [selectedItemsLabel]="'{0} region selected'" [disabled]="isAdmin && !isMsp" placeholder="Choose">
                <ng-template let-item pTemplate="item">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <input type="text" pInputText placeholder="{{'Search' | translate}}" [(ngModel)]="keyWord" class="pInputText" (ngModelChange)="searchKeyWord()">
          </div>
        </div>
      </div>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Payment Settings</h5>
        <div>
          <button pButton type="button" label="Edit" icon="fa fa-pencil-square-o" [disabled]="selectedNode == null" class="ui-button-danger update" (click)="showEditDialog()"></button>
        </div>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-treeTable [value]="treeRegionPayment" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20]" [columns]="monthlyPaymentTable_cols" selectionMode="single" [(selection)]="selectedNode">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns; let i= index">
              <th [ttSortableColumn]="col.field" [ttSortableColumnDisabled]="col.disabled"
              [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header | translate}}
              <p-treeTableSortIcon [field]="col.field" *ngIf="i !== 1"></p-treeTableSortIcon>
            </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr [ttSelectableRow]="rowNode">
            <td style="width: 250px;" class="col-nowrap" *ngIf="rowData.CompanyName !== '' && rowData.CompanyName !== undefined else noCmpName">
              <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              <span><a routerLink="/management/payment/document/{{rowData.HashMspRegionId}}">{{rowData.Company}}</a></span>
            </td>
            <ng-template #noCmpName>
              <td style="width: 250px;" class="col-nowrap">
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                <span>{{rowData.Company}}</span>
              </td>
            </ng-template>
            <td style="width:80px" class="col-nowrap">
              <span class="badge alert-warning opacity" *ngIf="rowData.IsDistributor">Distributor</span>
            </td>
            <td style="width:200px" class="col-nowrap">
              {{rowData.Region}}
            </td>
            <td style="width:150px" class="col-nowrap">
              <span>{{rowData.UnitPrice}}</span>
            </td>
            <td style="width:150px" class="col-nowrap nodes">
              <div class="flex between">
                <span>{{rowData.Nodes}}</span>
                <i class="fa fa-info-circle" pTooltip="{{ 'Your NPM is below the usage equivalent of one month.' | translate }}" tooltipPosition="bottom"
                tooltipStyleClass="warningTip" *ngIf="rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 1"></i>
                <i class="fa fa-info-circle" pTooltip="{{ 'Your NPM is below the usage equivalent of two months.' | translate }}" tooltipPosition="bottom"
                tooltipStyleClass="warningTip" *ngIf="rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 2"></i>
                <i class="fa fa-info-circle" pTooltip="{{ 'Your NPM is below the usage equivalent of three months.' | translate }}" tooltipPosition="bottom"
                tooltipStyleClass="warningTip" *ngIf="rowData.NpmBankWarning && rowData.NpmBankWarningMonth === 3"></i>
              </div>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.DocumentCreateTime}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="monthlyPaymentTable_cols.length">No Device found</td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
  </div>
  <div class="container-fluid">
    <div class="page-filter clearfix multiple-filter" style="margin: 4em 0 30px 0">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-select [options]="regionOptions" (onChange)="filter_record()" [baseZIndex]="10000" [(ngModel)]="filterRegion.RegionIdForRecord" [selectedItemsLabel]="'{0} region selected'" [disabled]="isAdmin && !isMsp">
              </p-select>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <p-multiSelect [options]="companyOptions" (onPanelHide)="filter_record()" [baseZIndex]="10000"  [(ngModel)]="selectedCompany" optionLabel="label" [selectedItemsLabel]="'{0} company selected'" placeholder="Choose"></p-multiSelect>
            </div>
          </div>
          <div class="filter-list">
            <div class="filter-content">
              <p-multiSelect [options]="yearOptions" (onPanelHide)="filter_record()" [baseZIndex]="10000"  [(ngModel)]="selectedYears" optionLabel="label" [selectedItemsLabel]="'{0} year selected'" placeholder="Choose"></p-multiSelect>
            </div>
          </div>
        </div>
        <div class="filter search float-right">
          <div class="button">
            <input type="text" pInputText placeholder="{{'Search' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
          </div>
        </div>
      </div>
    </div>
    <div class="page-filter clearfix border-b-radius-none" style="margin: 0">
      <div class="page-title sub-title">
        <h5 class="float-left">Payment Record</h5>
      </div>
    </div>
    <div class="page-content border-t-radius-none">
      <p-table class="deviceTable pageAllOptions" #dt [columns]="paymentRecordTable_cols" [value]="paymentRecordListFiltered" [paginator]="true" [rows]="10" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:50px" class="col-nowrap">
              <span>No</span>
            </th>
            <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
              <th [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            </ng-template>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr [pSelectableRow]="rowData">
            <td style="width:50px" class="col-nowrap">
              <span>{{i+1}}</span>
            </td>
            <td style="width:150px" class="col-nowrap">
              <span title="{{rowData.DocNo}}">{{rowData.DocNo}}</span>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.Company}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.DocType_Name}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.PaymentUsage}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>${{rowData.UnitPrice | number:'1.1-2'}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>${{rowData.TotalPrice | number:'1.1-1'}}</span>
            </td>
            <td style="width:180px" class="col-nowrap">
              <span>{{rowData.GenerateTime}}</span>
            </td>
            <td style="width:220px" class="col-nowrap">
              <span>{{rowData.CreateAccount}}</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="paymentRecordTable_cols.length">No Device found</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!--Payment Settings Dialog-->
<p-dialog header="Payment Settings" class="scrollDialog" [(visible)]="dialogVisibility.monthlyPayment" [modal]="true" [style]="{'width': '650px'}"[baseZIndex]="10000">
  <p-tabs class="settings_tabView" [tabindex]="selectDefaultTab" (valueChange)="onTabChange($event)" value="0">
    <p-tablist>
        <p-tab value="0">{{'Basic' | translate}}</p-tab>
        <p-tab value="1">{{'Recipient ' | translate}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="dialog-content">
          <!-- <div class="form-group">
            <label>Document Type</label>
            <div class="select">
              <p-select [options]="documentOptions" [(ngModel)]="dialogInput.DocType" [style]="{'width':'100%'}"></p-select>
            </div>
          </div> -->
          <div class="form-group">
            <label>Distributor</label>
            <div *ngIf="!selectedNode?.data?.IsCustomer">
              <p-checkbox [(ngModel)]="dialogInput.IsDistributor" [binary]="true"></p-checkbox>
            </div>
            <div *ngIf="!selectedNode?.data?.IsDistributor">
              <input type="text" size="30" class="form-control pInputText" pInputText [ngModel]="selectedNode?.parent?.data.Company" [disabled]="true">
            </div>
          </div>
          <div class="form-group" *ngIf="selectedNode?.data?.IsCustomer">
            <label>NPM usage</label>
            <div class="select">
              <p-select [options]="npmUsageOptions" [(ngModel)]="dialogInput.NpmUsageType" (onChange)="onReminderToggle($event)" [style]="{'width':'100%'}"></p-select>
            </div>
          </div>
          <div class="form-group" *ngIf="dialogInput.IsDistributor">
            <label>Customer</label>
            <div class="select">
              <p-multiSelect [options]="customerOptions" [(ngModel)]="dialogInput.Customers" [baseZIndex]="10000" [selectedItemsLabel]="'{0} ' + ('company selected' | translate)" (onPanelShow)="onPanelShow();" (onPanelHide)="onPanelHide();" [virtualScroll]="true" [virtualScrollItemSize]="20">
                <ng-template let-item pTemplate="item">
                  <span>{{item.label}}</span>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
          <!-- <div class="isDistributor" *ngIf="dialogInput.IsDistributor || dialogInput.IsCustomer">
            <div class="form-group flex" *ngIf="dialogInput.IsDistributor">
              <p-toggleswitch [(ngModel)]="dialogInput.SyncSetting"></p-toggleswitch>
              <span>Synchronize payment settings with the distributor</span>
              <i class="fa fa-info-circle" pTooltip="{{'Include Unit Price, Company Name, Statement Recipient, Address, and Email' | translate}}" tooltipPosition="bottom"
              tooltipStyleClass="available"></i>
            </div>
          </div> -->
          <div class="form-group">
            <label>Unit Price</label>
            <div class="select">
              <p-inputNumber [showButtons]="true" [min]="1" [max]="99.99" [step]="0.01" [(ngModel)]="dialogInput.UnitPrice" (onChange)="replaceToFixed($event)"></p-inputNumber>
              <p-message severity="error" text="{{'UnitPrice is required' | translate}}" *ngIf="this.dialogInput.UnitPrice == '' || this.dialogInput.UnitPrice == null"></p-message>
            </div>
          </div>
          <div class="form-group">
            <label>Minimum quantity of NPM per month</label>
            <div class="select">
              <p-inputNumber [showButtons]="true" [min]="0" [step]="1" [(ngModel)]="dialogInput.MinCharge"></p-inputNumber>
              <p-message severity="error" text="{{'Minimum Charge is required' | translate}}" *ngIf="this.dialogInput.MinCharge == null"></p-message>
            </div>
          </div>
          <div class="isDistributor">
            <div class="form-group flex">
              <p-toggleswitch [(ngModel)]="dialogInput.IsNotSendReminder" [disabled]="dialogInput.IsCustomer && dialogInput.NpmUsageType === 0"></p-toggleswitch>
              <span> This PPC account does not need to send payment reminders. </span>
            </div>
            <div class="form-group flex">
              <p-toggleswitch [(ngModel)]="dialogInput.IsNotAllowLock" [disabled]="dialogInput.IsCustomer && dialogInput.NpmUsageType === 0"></p-toggleswitch>
              <span> This PPC account will not be locked. </span>
            </div>
          </div>
          <!-- <div class="form-group" *ngIf="dialogInput.DocType !== 0">
            <label>Monthly Payment Generate Date</label>
            <div class="select">
              <p-inputNumber [showButtons]="true" [min]="1" [max]="28" [(ngModel)]="dialogInput.DocDay"></p-inputNumber>
              <p-message severity="error" text="{{'Monthly Payment Generate Date is required' | translate}}" *ngIf="this.dialogInput.DocDay == null"></p-message>
            </div>
          </div> -->
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="dialog-content">
          <div class="form-group" style="margin-bottom: 0 !important;">
            <label>Statement Recipient</label>
          </div>
          <p-table class="recipientTable" [ngClass]="{'border-top': recipientList.length> 0 }" [value]="recipientList" [(selection)]="selectedNode" [paginator]="false" [rows]="10" [scrollable]="true">
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr [pSelectableRow]="rowData">
                <td class="col-nowrap">
                  <div class="recipient">
                    <div class="icon">
                      <span class="fa-stack fa-lg">
                        <i class="fa fa-circle fa-stack-2x"></i>
                        <i class="fa-stack-1x name">{{rowData.Receiver.substr(0,1)}}</i>
                      </span>
                    </div>
                    <div class="data">
                      <h5 style="margin: 0;">{{rowData.Receiver}}</h5>
                      <p>{{ mailRecipientMap[rowData.ReceiverType] || '' }}</p>
                    </div>
                  </div>
                </td>
                <td class="col-btn" style="width:40px">
                  <button pButton icon="fa fa-edit" (click)="showEditRecipientDialog(rowData)"></button>
                </td>
                <td class="col-btn" style="width:50px">
                  <button pButton icon="fa fa-trash" (click)="deleteRecipientData(rowData)"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <ul class="list-group key-list">
            <li class="list list-group-item" [ngClass]="{'border-top': recipientList.length> 0 }">
              <a class="add-link" (click)="showAddRecipientDialog()">
                <div class="icon">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-plus fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
                <div class="data">
                  Add E-mail
                </div>
              </a>
            </li>
          </ul>
          <div class="form-group" style="margin-top: 1.2rem; margin-bottom: 0!important;">
            <label>Company Name</label>
            <input class="form-control pInputText" pInputText [(ngModel)]="dialogInput.CompanyName">
            <p-message severity="error" text="{{'Company Name is required' | translate}}" *ngIf="dialogInput.CompanyName == '' || this.dialogInput.CompanyName == null"></p-message>
          </div>
          <div class="form-group" style="margin-top: 1.2rem; margin-bottom: 0!important;">
            <label>Address</label>
            <input class="form-control pInputText" pInputText [(ngModel)]="dialogInput.Address">
          </div>
          <div class="form-group" style="margin-top: 1.2rem; margin-bottom: 0!important;">
            <label>E-mail</label>
            <input type="email" class="form-control pInputText" pInputText [(ngModel)]="dialogInput.CompanyEmail" pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #revEmail="ngModel">
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <ng-template #footer>
    <button type="button" pButton label="Save" (click)="saveMonthlyPaymentMgt()" [disabled]="(dialogInput.CompanyName == '' || this.dialogInput.CompanyName == null) || (dialogInput.UnitPrice == '' || this.dialogInput.UnitPrice == null) || (dialogInput.UnitPrice == 'dialogInput.MinCharge' || this.dialogInput.MinCharge == null)" class="ui-button-danger"></button>
    <button type="button" pButton (click)="dialogVisibility.monthlyPayment=false;" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Recipient -->
<p-dialog header="{{dialogRecipientInput.UpdateType}}" [(visible)]="dialogVisibility.recipient" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label>E-mail</label>
      <input type="email" class="form-control pInputText" pInputText [(ngModel)]="dialogRecipientInput.Receiver" pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
        #emailAccount="ngModel">
      <p-message severity="error" text="{{'Email is invalid'}}" *ngIf="emailAccount.invalid && (emailAccount.dirty || emailAccount.touched)"></p-message>
    </div>
    <div class="form-group">
      <label>Recipient</label>
      <div class="select">
        <p-select [options]="recipientOptions" [(ngModel)]="dialogRecipientInput.ReceiverType" [style]="{'width':'100%'}"></p-select>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton label="Save" (click)="saveAddRecipient();dialogVisibility.recipient=false;" [disabled]="emailAccount.invalid || emailAccount.value === ''" class="ui-button-danger"></button>
    <button type="button" pButton (click)="dialogVisibility.recipient=false;" label="Cancel" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<!-- Confirm -->
<p-dialog header="Confirm" [(visible)]="dialogVisibility.confirm" [modal]="true" [style]="{'width': '450px'}" class="ConfirmDialog distributeDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p style="padding-bottom: 10px;">Please check the payment settings below :</p>
    <ul class="alert alert-warning">
      <li>
        <span class="title">Document Type :</span>
        <span>{{dcoumentType_name}}</span>
      </li>
      <li>
        <span class="title">Distributor :</span>
        <span>{{(dialogInput.IsDistributor) ? 'Yes' : 'No'}}</span>
      </li>
      <li>
        <span class="title" *ngIf="dialogInput.Customers.length > 0">Customers :</span>
        <span>{{customers_str}}</span>
      </li>
      <li>
        <span class="title">Unit Price :</span>
        <span>{{dialogInput.UnitPrice}}</span>
      </li>
      <li>
        <span class="title">Minimum quantity of devices to charge :</span>
        <span>{{dialogInput.MinCharge}}</span>
      </li>
      <!-- <li *ngIf="dialogInput.DocType !== 0">
        <span class="title w100">Monthly Payment Generate Date :</span>
        <span>{{dialogInput.DocDay}}</span>
      </li> -->
      <li>
        <span class="title" *ngIf="recipient_main !== ''">Main Recipient :</span>
        <span>{{recipient_main}}</span>
      </li>
      <li>
        <span class="title" *ngIf="recipient_cc !== ''">CC :</span>
        <span>{{recipient_cc}}</span>
      </li>
      <li>
        <span class="title" *ngIf="recipient_bcc !== ''">BCC :</span>
        <span>{{recipient_bcc}}</span>
      </li>
      <li *ngIf="dialogInput.CompanyName !== ''">
        <span class="title">Company Name :</span>
        <span>{{dialogInput.CompanyName}}</span>
      </li>
      <li *ngIf="dialogInput.Address !== ''">
        <span class="title">Address :</span>
        <span>{{dialogInput.Address}}</span>
      </li>
      <li *ngIf="dialogInput.CompanyEmail !== ''">
        <span class="title">CompanyEmail :</span>
        <span>{{dialogInput.CompanyEmail}}</span>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <div class="page-content-btn">
      <button type="button" pButton label="Confirm" class="ui-button-danger" (click)="confirmMonthlyPayment()"></button>
      <button type="button" pButton (click)="dialogVisibility.confirm=false" label="Cancel" class="p-button-secondary"></button>
    </div>
  </ng-template>
</p-dialog>
